var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TraderInformation"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("TraderInformation.title")))]),_c('div',{staticClass:"info-view"},[_vm._m(0),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.showInfo))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/images/TraderInformation/user.png"),"alt":""}})])
}]

export { render, staticRenderFns }